import React from "react";
import styled from "styled-components";
import Button from "@airasia/phoenix-components/components/Button";

import { GTM_PROJECT_CATEGORY } from "../utils/constants";
import { getGtmUserType, fireGtmEvent } from "../utils/functions";

const TextContainer = styled.div`
        width:60%;
        margin-right:3%;

        @media only screen and (max-width: 694px){
          width:100%;
        }
`;

const BecomeMerchant = styled.div`
    margin:5% auto;
    background:#fff;
    display:flex;
    align-items:center;
    padding:2%;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.16);
    border-radius: 4px;

    #ctaButton{width:30%;}       

    @media only screen and (max-width: 694px){
      display:block;
      padding:7%; 
      margin:4rem auto;

      #ctaButton{width:90%}
    }      
          
    `;

export default function cta(props) {
    const cardData = props.data;
    const renderCard = (card, index) => {
        return (
          <BecomeMerchant>
              <TextContainer>
                    <h2>Become our merchant partner</h2>
                    <p>Come join us as an airasia food partner. Get more customers on one of the best online food delivery apps and see your business grow with airasia Super App!</p>
                </TextContainer>
                <Button
                    accessible
                    buttonType="button"
                    boxShadow
                    customProperties={{
                      id: 'ctaButton',
                      paddingBottom: '0.5rem',
                      paddingLeft: '1rem',
                      paddingRight: '1rem',
                      paddingTop: '0.5rem'
                    }}
                    margin={[
                      'small',
                      'none',
                      'none',
                      'none'
                    ]}
                    fontWeight="bold"
                    size="normal"
                    target="tab"
                    width="80%"
                    type="normal"
                    color="default"
                    target="tab"
                    backgroundColor="primary"
                    handleClick={() => {
                      fireGtmEvent({
                        "event": 'trackEventNoEcommerce',
                            "eventDetails.category": "Become Foor Merchant | Be our merchant | Restaurant Lists",
                            "eventDetails.action": "click",
                            "eventDetails.label": `Be our merchant | ${getGtmUserType()}`
                      })
                      window.open("https://www.airasia.com/aa/become-food-merchant/")
                    }}
                  >
                    Be our merchant
                  </Button>
</BecomeMerchant>
        );
    }
    return (
        cardData.map(renderCard)
    );
}

